/* eslint-disable indent */
import { Box, Button } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import SendIcon from '@material-ui/icons/Send';
import Alert from '@material-ui/lab/Alert';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import { submitForm } from '../../api/form';
import { getTask } from '../../api/task';
import { submitFile } from '../../api/upload';
import { ApiContext } from '../../contexts/ApiContext';
import { mainishStyles } from '../../styling';
import { incorrectFileTypeMessage } from '../../utils/constant';
import { arrToString } from '../../utils/transformer';
import { DialogCommon, useDialog } from '../Common/DialogContext';
import {
  InputField,
  ReactHookFormComboBox,
  ReactHookFormDatePicker,
  ReactHookFormUpload,
} from '../Common/Form';
import { useSnackBar } from '../Common/SnackBarContext';
import { uploadData } from './formData';
import {
  TokenDialogActions,
  TokenDialogContent,
  TokenDialogTitle,
} from './TokenDialogParts';

export default function StepTwo() {
  const location = useLocation();
  const [tasks, setTasks] = useState([]);
  // const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  const getTaskFunc = useCallback(async (category) => {
    try {
      const res = await getTask(apiContext.axios, category);
      setTasks(res.data);
    } catch (e) {
      snackBarHelper.openSnackBar('error', String(e));
    }
  });

  useEffect(async () => {
    const category = location?.state['Permintaan Pelayanan'];
    await getTaskFunc(category);
  }, [getTask]);

  const formclasses = mainishStyles();
  const { handleSubmit, register, control, errors } = useForm({
    mode: 'onBlur',
  });
  const apiContext = useContext(ApiContext);
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const snackBarHelper = useSnackBar();

  const dialogHelper = useDialog();

  const tokenDialog = (token) =>
    dialogHelper.openDialog(
      <TokenDialogTitle />,
      <TokenDialogContent token={token} />,
      <TokenDialogActions />
    );

  const onSubmit = async (data) => {
    snackBarHelper.openSnackBar('info', 'Mengirim...');
    if (loading !== null) {
      setLoading(true);
    }
    try {
      const res = await submitFile(
        apiContext.axios,
        location.state[uploadData[0].attr][0]
      );
      if (res) {
        // console.log(tasks);
        try {
          location.state['taskResponses'] = [];
          let i = 0;
          for (const taskResponse in tasks) {
            const response =
              tasks[i]['widget'] === 'File'
                ? data[tasks[taskResponse]['name']].length > 0
                  ? await submitFile(
                      apiContext.axios,
                      data[tasks[taskResponse]['name']][0]
                    )
                  : null
                : tasks[i]['widget'] === 'TextField'
                ? data[tasks[taskResponse]['name']]
                : tasks[i]['widget'] === 'Option'
                ? data[tasks[taskResponse]['name']]
                : null;
            if (response && response !== '') {
              const taskID = tasks[i]['id'];
              const taskObj = { task: taskID, response: response };
              location.state['taskResponses'].push(taskObj);
            }
            i++;
          }
          const sub = await submitForm(apiContext.axios, location.state, res);
          if (sub) {
            snackBarHelper.openSnackBar('success', 'Permintaan dikirim');
            tokenDialog(sub.id);
          }
        } catch (err) {
          snackBarHelper.openSnackBar('error', err.toString());
        }
      }
    } catch (e) {
      snackBarHelper.openSnackBar('error', e.toString());
    }
    if (loading !== null) {
      setLoading(false);
    }
  };

  const clickPrev = async (e) => {
    try {
      e.preventDefault;
      history.push({ pathname: './', state: location.state });
    } catch (e) {
      snackBarHelper.openSnackBar('error', String(e));
    }
  };

  return (
    <div>
      <form
        className={formclasses.formCommons}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Box flexDirection="column">
          {tasks.map((task, i) =>
            task.widget === 'File' ? (
              <ReactHookFormUpload
                key={i}
                attr={task?.name}
                label={task?.name}
                register={register}
                error={errors[task?.name]}
                rules={
                  task?.widget_parameters.type !== null &&
                  task?.widget_parameters.type !== ''
                    ? {
                        ...task?.widget_parameters.rules,
                        validateType: {
                          value: null,
                          message: incorrectFileTypeMessage,
                        },
                      }
                    : task?.widget_parameters.rules
                }
                // placeholder={task?.description}
                addInfo={task?.description}
                acceptedType={arrToString(task?.widget_parameters.type, '')}
              />
            ) : task.widget === 'TextField' ? (
              task?.widget_parameters.type === 'date' ? (
                <ReactHookFormDatePicker
                  key={i}
                  attr={task?.name}
                  rules={task?.widget_parameters.rules}
                  error={errors[task?.widget_parameters.attr]}
                  control={control}
                  fullWidth={true}
                  isTask={true}
                  // shrink={true}
                />
              ) : (
                <InputField
                  key={i}
                  isTask={true}
                  addInfo={task?.description}
                  req={task?.widget_parameters.req}
                  type={task?.widget_parameters.type}
                  attr={task?.name}
                  // shrink={true}
                  rules={task?.widget_parameters.rules}
                  register={register}
                  error={errors[task?.widget_parameters.attr]}
                />
              )
            ) : task.widget === 'Option' ? (
              <ReactHookFormComboBox
                key={i}
                attr={task?.name}
                options={task?.widget_parameters.options}
                isTask={true}
                addInfo={task?.description}
                rules={task?.widget_parameters.rules}
                error={errors[task?.widget_parameters.attr]}
                control={control}
                req={task?.widget_parameters.req}
                // register={register}
              />
            ) : null
          )}
          <Box
            style={{
              width: '100%',
              display: 'flex',
            }}
          >
            <Button
              disabled={loading}
              type="button"
              variant="contained"
              color="primary"
              onClick={clickPrev}
              stylle={{
                display: 'inline-flex',
                marginRight: 'auto',
                marginLeft: 0,
              }}
            >
              Sebelumnya
            </Button>
            <Button
              disabled={loading}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SendIcon />}
              style={{
                position: 'inline',
                display: 'flex',
                marginRight: 0,
                marginLeft: 'auto',
              }}
            >
              Kirim
            </Button>
          </Box>
        </Box>
      </form>

      <DialogCommon />
      <Collapse in={loading}>
        <Alert elevation={6} variant="filled" severity="info">
          Harap tetap di laman ini selama formulir Anda dikirim
        </Alert>
      </Collapse>
    </div>
  );
}
